const loginCallBack = async ({
  closeModal,
  closeModalAction,
  onLogInComplete,
  postLoginAction,
}) => {
  await closeModalAction({ close: closeModal });
  setTimeout(() => {
    if (postLoginAction) {
      postLoginAction();
    } else {
      document.documentElement.classList.remove('locked');
      onLogInComplete();
    }
  }, 201);
};

export default ({
  openModalAction,
  closeModalAction,
  createLoginModal,
  loginModalData,
}) => {
  const {
    device,
    mobileOs,
    viewportHeight,
    portalDomain,
    accountDomain,
    authBasePrefix,
    logIn,
    onLogInComplete,
    postLoginAction,
    cookiesConfig,
    reCAPTCHA,
    from,
    position,
    createConsentRequestModal,
    createConsentMandatoryModal,
    refreshUser,
    proxyBase,
  } = loginModalData;

  openModalAction(createLoginModal({
    device,
    mobileOs,
    viewportHeight,
    portalDomain,
    accountDomain,
    authBasePrefix,
    logIn,
    onLogInComplete,
    postLoginAction,
    cookiesConfig,
    reCAPTCHA,
    loginCallBack,
    from,
    position,
    createConsentRequestModal,
    createConsentMandatoryModal,
    refreshUser,
    proxyBase,
    loginCallBackPayload: {
      openModalAction,
      closeModalAction,
      onLogInComplete,
      postLoginAction,
    },
  }));
};
